<script setup>
import { ref, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const auth = useAuthStore();
const router = useRouter();

const email = ref('');
const password = ref('');

watchEffect(() => {
  if (auth.ui.prefillEmail) email.value = auth.ui.prefillEmail;
});

async function onSubmit() {
  const ok = await auth.login(email.value, password.value);
  if (!ok) return;
  await auth.fetchAccessMe();
  const target = auth.ui.loginRedirect;
  auth.hideLogin();
  if (target) router.push(target);
}
</script>

<template>
  <div
      v-if="auth.ui.loginVisible"
      id="login-modal"
      role="dialog"
      aria-modal="true"
      class="fixed inset-0 z-[1000] flex items-center justify-center"
  >
    <div class="absolute inset-0 bg-black/50" @click="auth.hideLogin()" />
    <div class="relative bg-white w-full max-w-sm rounded-xl shadow-lg p-5">
      <div class="flex items-center justify-between mb-3">
        <h2 class="text-lg font-semibold">{{ auth.ui.loginTitle }}</h2>
        <button class="text-gray-500 hover:text-gray-800" @click="auth.hideLogin()">✕</button>
      </div>

      <form class="space-y-3" @submit.prevent="onSubmit">
        <div>
          <label class="block text-sm font-medium mb-1">E-Mail</label>
          <input v-model="email" type="email" required class="w-full border rounded-md px-3 py-2" />
        </div>

        <div>
          <label class="block text-sm font-medium mb-1">Passwort</label>
          <input v-model="password" type="password" required class="w-full border rounded-md px-3 py-2" />
        </div>

        <button type="submit" class="w-full bg-blue-600 text-white rounded-md py-2 disabled:opacity-60">
          {{ auth.loading ? 'Bitte warten…' : 'Einloggen' }}
        </button>

        <p v-if="auth.error" class="text-red-600 text-sm">{{ auth.error }}</p>
      </form>
    </div>
  </div>
</template>
